// context/SessionContext.tsx
import { createContext, useState } from 'react';
import { GetQueryParams } from '../types/api.type';

export const SessionContext = createContext<{
  selectedScope: string;
  setSelectedScope: (scope: string) => void;
  removeSelectedScope: () => void;
  filters: GetQueryParams | null;
  setFilters: (filters: GetQueryParams) => void;
  clearFilters: () => void;
} | null>(null);

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedScope, setSelectedScope] = useState<string>('upcoming');
  const [filters, setFilters] = useState<GetQueryParams | null>(null);

  const removeSelectedScope = () => {
    setSelectedScope('upcoming');
  };

  const clearFilters = () => {
    setFilters({
      scope: selectedScope ?? 'upcoming',
      data: { page: 1, entries: 20, filterBy: [] }
    });
  };

  return (
    <SessionContext.Provider
      value={{
        selectedScope,
        setSelectedScope,
        removeSelectedScope,
        filters,
        setFilters,
        clearFilters
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};
